<template>
  <v-row id="product-list">
    <v-col cols="12">
      <v-row
        v-for="(product, index) in products"
        :key="`product-${index}`"
        class="products-row">
        <!-- <v-col class="product-col-left d-none d-sm-block">
          <div class="product-image">
            <img
              v-if="product.photoUrls && product.photoUrls.length > 0"
              :src="product.photoUrls[0]"
              width="80">
            <svg-icon
              v-else
              svg-name="shirt"
              width="80"
              height="80" />
          </div>
        </v-col> -->
        <v-col class="product-col-right">
          <v-row class="product-detail">
            <v-col
              class="product-detail-left"
              cols="12">
              <h4 class="subtitle-1 font-weight-bold">
                {{ product.name }}
              </h4>
            </v-col>
          </v-row>
          <v-row class="product-skus mt-1">
            <v-col
              cols="12"
              class="px-0">
              <v-simple-table class="skus-table pa-3 pt-0">
                <thead>
                  <tr>
                    <th>
                      code
                    </th>
                    <th class="text-center">
                      {{ product.variant1 }}
                    </th>
                    <th class="text-center">
                      {{ product.variant2 }}
                    </th>
                    <th class="text-center">
                      price
                    </th>
                    <th class="text-center">
                      Instock (Reserved)
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(sku, i) in product.skus"
                    :key="`skus-${i}`">
                    <td>
                      {{ sku.code }}
                    </td>
                    <td align="center">
                      {{ sku.option1 }}
                    </td>
                    <td align="center">
                      {{ sku.option2 }}
                    </td>
                    <td align="center">
                      {{ sku.price | showFullPriceFormat() }}
                    </td>
                    <td align="center">
                      {{ sku.stock }} ({{ sku.remainingInBill }})
                    </td>
                    <td align="center">
                      <v-btn
                        icon
                        :class="isOutOfStock(sku.stock, sku.remainingInBill) ? 'add-to-bag-disable' : 'add-to-bag'"
                        @click="isOutOfStock(sku.stock, sku.remainingInBill) === true ? () => {} : addToCart(product, sku)">
                        <img
                          src="@/assets/image/shopping-bag.png"
                          alt="shopping-bag"
                          class="d-block"
                          width="20"
                          height="20">
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    products: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    isOutOfStock (instock, reserved) {
      return instock - reserved <= 0
    },
    addToCart (product, sku) {
      const productSku = {
        id: sku.id,
        code: sku.code,
        name: product.name,
        variant1: product.variant1,
        variant2: product.variant2,
        option1: sku.option1,
        option2: sku.option2,
        amount: 1,
        price: sku.price
      }
      this.$emit('onAddtoCart', productSku)
    }
  }
}
</script>

<style scoped>
.product-attribute-left {
  width: 250px;
  flex: 0 0 250px;
}
.product-col-right .row .col {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.product-col-left {
  width: 150px;
  flex: 0 0 150px;
}
.edit-product-btn.col {
  position: absolute;
  width: fit-content;
  top: auto;
  right: 0;
}
.product-detail {
  position: relative;
}
.products-row {
  padding: 10px 0;
}
.product-image {
  display: block;
  width: 100px;
  padding: 5px;
  margin: 0 auto;
  border: 1px dashed #676767;
  background-color: #fff;
}
.loader-product-list .v-skeleton-loader__avatar {
  width: 100px;
  height: 100px;
}
.loader-product-list {
  padding: 15px 0;
}
.skus-table th {
  text-transform: capitalize;
}
.skus-table td,
.skus-table th {
  padding: 0 5px;
}
.skus-table th:nth-child(1),
.skus-table td:nth-child(1) {
  width: 20%;
}
.skus-table th:nth-child(2),
.skus-table td:nth-child(2),
.skus-table th:nth-child(3),
.skus-table td:nth-child(3) {
  width: 15%;
}
.skus-table th:nth-child(4),
.skus-table td:nth-child(4) {
  width: 20%;
}
.add-to-bag {
  background-color: #fff;
  cursor: pointer;
  transition: all 0.1s;
}
.add-to-bag-disable {
  background-color: #a4a4a4;
  cursor: not-allowed;
}
.add-to-bag:active {
  transform: scale(1.2);
}
.skus-table > table {
  margin-bottom: 10px;
}
@media screen and (max-width: 600px) {
  .skus-table td {
    font-size: 10px;
  }
}
</style>
